import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';

const VGrammar = lazy(async () => {
  const { VGrammar } = await import('../sites/vgrammar');
  return { default: VGrammar };
});
const VGrammarExample = lazy(async () => {
  const { Example } = await import('../sites/vgrammar/views/example');
  return { default: Example };
});
const VGrammarDemo = lazy(async () => {
  const { Demo } = await import('../sites/vgrammar/views/demo');
  return { default: Demo };
});
const VGrammarGuide = lazy(async () => {
  const { Guide } = await import('../sites/vgrammar/views/guide');
  return { default: Guide };
});
const VGrammarOption = lazy(async () => {
  const { Option } = await import('../sites/vgrammar/views/option');
  return { default: Option };
});
const VGrammarAPI = lazy(async () => {
  const { API } = await import('../sites/vgrammar/views/api');
  return { default: API };
});
const VGrammarEntry = lazy(async () => {
  const { Entry } = await import('../sites/vgrammar/views/entry');
  return { default: Entry };
});

export const vgrammarRoutes: RouteObject[] = [
  {
    path: '/vgrammar',
    element: (
      <Suspense>
        <VGrammar />
      </Suspense>
    ),
  },
  {
    path: '/vgrammar/example',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VGrammarExample />
      </Suspense>
    ),
  },
  {
    path: '/vgrammar/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VGrammarGuide />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VGrammarGuide />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vgrammar/demo',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VGrammarDemo />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VGrammarDemo />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vgrammar/option',
    loader: loaders.optionLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VGrammarOption />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VGrammarOption />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vgrammar/api',
    loader: loaders.apiLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VGrammarAPI />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VGrammarAPI />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vgrammar/entry',
    loader: loaders.entryLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VGrammarEntry />
      </Suspense>
    ),
  },
];
